import React from 'react'
import LoginForm from '../components/LoginForm'

export default function LoginPage() {
  return (
    <div>
      <h1>Login</h1>
      <LoginForm />
    </div>
  )
}
